import VirtualPath from 'meta/utils/virtualPath';
export function addScript(src, win = window) {
    return new Promise((res) => {
        let s = win.document.createElement('script');
        const _src = src.startsWith('@')
            ? src.replace('@', `${VirtualPath}/_Frontend/dist/modules/`) + '.js'
            : src;
        s.setAttribute('src', _src);
        s.onload = res;
        win.document.body.appendChild(s);
    });
}
export function evalScript(script, win = window) {
    // @ts-ignore TypeScript doesn't include the eval() method on window objects
    win.eval(String(script));
}
